module.exports = __webpack_public_path__ + "static/img/7425_phase_function_Paper_PointsHejduk_Prediction.7a34343.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/7425_phase_function_Paper_PointsHejduk_Prediction.png
// module id = +xr5
// module chunks = 0